import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {Session} from 'nutshell-core/session';

import {FormField} from '../form/form-field';
import {FormattedNumberField} from '../formatted-number-field/formatted-number-field';

import styles from './number.module.css';

type Props = FieldProps & {
    title?: string;
    placeholder?: string;
    helperText?: string;
    isRequired?: boolean;
    formatType?: 'currency' | 'number' | 'float' | 'percent';
    currencyCode?: string;
};

export function ReduxFormNumberField(props: Props) {
    React.useEffect(() => {
        if (props.formatType === 'currency' && props.input.value) {
            const numericValue =
                typeof props.input.value === 'string'
                    ? parseFloat(props.input.value.replace(/[^0-9.-]+/g, ''))
                    : props.input.value;

            if (!isNaN(numericValue)) {
                props.input.onChange(formatValue(numericValue));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currencyCode]);

    const formatValue = (newValue?: number | null) => {
        if (!newValue) return null;

        if (props.formatType === 'currency') {
            return newValue.toLocaleString(undefined, {
                style: 'currency',
                currency: props.currencyCode ?? Session.getInstanceDefaultCurrencyCode(),
            });
        } else {
            return newValue;
        }
    };

    return (
        <FormField
            innerId={props.input.name}
            label={props.title}
            helperText={props.helperText}
            errorMessage={props.meta.error && props.meta.submitFailed ? props.meta.error : null}
            isRequired={props.isRequired}
        >
            <div className={styles.container}>
                <FormattedNumberField
                    {...props.input}
                    formatType={props.formatType || 'number'}
                    currencyCode={props.currencyCode}
                    onChange={(value?: number | null) => {
                        props.input.onChange(formatValue(value));
                    }}
                    placeholder='0'
                    clearable={true}
                    min={props.formatType === 'percent' ? 0 : undefined}
                    max={props.formatType === 'percent' ? 100 : undefined}
                />
                {props.formatType === 'percent' ? <div className={styles.percent}>%</div> : null}
            </div>
        </FormField>
    );
}
